/**
 * `useIntelHelp` — Amendment 1 §1/§A.3's `GET intelligence/help` wrapper, the same thin
 * shape as `api.ts`'s other TanStack wrappers (`useUseCases`): the fetcher, the type and
 * the query key all live in `lib/api.ts` beside every other endpoint; this is only the
 * query-object boilerplate `Help.tsx` would otherwise carry itself.
 */
import { useQuery } from '@tanstack/react-query';

import { fetchIntelHelp, queryKeys } from '../../lib/api';

export function useIntelHelp() {
  return useQuery({ queryKey: queryKeys.intelHelp(), queryFn: () => fetchIntelHelp() });
}
